import init from '../helpers/init'

function SelectrProvider() {
  return context => {
    context.selectr = {
      destroy(name) {
        console.warn(
          'Cerelbral-selectr destroy is deprected. Use update to set new values'
        )
        context.state.unset(`selectr.${name}`)
      },
      destroyAll() {
        console.warn(
          'Cerelbral-selectr destroyAll is deprected. Use update to set new values'
        )
        const selectr = context.state.get('selectr')
        if (selectr) {
          Object.keys(selectr).forEach(select => {
            context.state.unset(`selectr.${select}`)
          })
        }
      },
      create(options) {
        console.warn(
          'Cerelbral-selectr create is deprected. Use update to set new values'
        )
        init({ ...options }, context.state)
      },
      update(options) {
        init({ ...options, reset: true }, context.state)
      }
    }

    if (context.debugger) {
      context.debugger.wrapProvider('selectr')
    }

    return context
  }
}

export default SelectrProvider
